import { render, staticRenderFns } from "./session-competitors.vue?vue&type=template&id=216d1e70&"
import script from "./session-competitors.vue?vue&type=script&lang=js&"
export * from "./session-competitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports